import { render, staticRenderFns } from "./RegVender.vue?vue&type=template&id=bdd0f534"
import script from "./RegVender.vue?vue&type=script&lang=js"
export * from "./RegVender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports